module.exports = __webpack_public_path__ + "img/idea.3469ebdb.svg";